import { render, staticRenderFns } from "./result.vue?vue&type=template&id=d7cb0e40&scoped=true"
import script from "./result.vue?vue&type=script&lang=js"
export * from "./result.vue?vue&type=script&lang=js"
import style0 from "./result.vue?vue&type=style&index=0&id=d7cb0e40&prod&scoped=scoped&lang=scss"
import style1 from "./result.vue?vue&type=style&index=1&id=d7cb0e40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7cb0e40",
  null
  
)

export default component.exports